import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#4A5568",
      "fill-rule": "evenodd",
      d: "M15.657 15.657A8 8 0 1 1 4.343 4.342a8 8 0 0 1 11.314 11.315m-6.27-7.792v5.332q0 .47.217.71.216.24.574.24.802 0 .802-1.178v-6.71q0-.42-.187-.661a.6.6 0 0 0-.498-.24q-.276 0-.375.105-.1.105-.428.562t-.756.827q-.421.369-1.13.703-.476.223-.663.363t-.187.44q0 .257.187.456a.6.6 0 0 0 .44.194q.516 0 2.004-1.143",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }